import React from 'react';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import ProductListItem from "../../components/ProductListItem/ProductListItem.js";
import { ReactSVG } from "react-svg";

import './Wishlist.css'; 

class Wishlist extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      products: [],
      hiding: false,
      show: false,
      edit: false,
    };
  }

  show() {
    this.setState({
      show: true, 
      products: window.AppRef.current.state.favorites
    });
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  handle_edit_click() {
    let { edit } = this.state;

    this.setState({edit: !edit}, () => { this.show(); });
  }

  handle_product_click(event, product) {
    let { edit } = this.state;
    
    if (event.target.nodeName === 'IMG')
    {
      if (!edit)
      {
        window.modals.ProfileMenuRef.current.hide();
        this.hide();
      }
      else {
        event.preventDefault();
      }
    }
  }

  render() {
    const { products, edit, show, hiding } = this.state;

    if (!show) return '';

    const edit_button = !!edit 
      ? <button type="button" onClick={() => this.handle_edit_click()}>{i18n.t('wishListReady')}</button> 
      : <ReactSVG className="edit" src="assets/images/edit_black.svg" onClick={() => this.handle_edit_click()} />;

    return <div className={`container page_checkout page_wishlist ${hiding ? 'out' : ''}`}>
          <div className="content">
          
          <PageHeader parent_ref={this} title={i18n.t('wishListTitle')} custom_icons={products && products.length ? [edit_button] : []} />
          
          <div className='container_inner'>
            {products && products.length ? <div className="product_list_items">
              {products.map(product => 
              <ProductListItem 
              key={`${product.id}-${edit}`} 
              product={product} 
              parentFunction={(e,product) => this.handle_product_click(e, product)} 
              on_fav_click={(product) => {
                window.AppRef.current.product_fav_delete(null, {product: product, on_resolve: (res, product) => {
                  this.setState({ products: window.AppRef.current.state.favorites });
                }});
              }}
              show_fav_icon={edit} />)}
            </div>
            : <div className='emplty_list_message'>{i18n.t('wishListEmpty')}</div>}
          </div>

          </div>
      </div>;
  }
}

export default Wishlist;